// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2OSzl","load3":"Spinner_load3__19azw"};